var map = {
	"./Dashboard.tsx": 469,
	"./Declare.tsx": 467,
	"./Edumain.tsx": 449,
	"./Eduresult.tsx": 465,
	"./Exam.tsx": 466,
	"./Faq.tsx": 450,
	"./Intro.tsx": 451,
	"./Login.tsx": 452,
	"./Mudlogin.tsx": 453,
	"./Mudmanage.tsx": 455,
	"./Mypage.tsx": 456,
	"./Target.tsx": 468,
	"./Template.tsx": 462
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 980;